import { Button as ButtonAntD } from 'antd';
import styled from 'styled-components';

import { COLORS } from '../../../../utils/theme/colors';

export const Wrapper = styled.div`
  margin: 0 auto;

  .ant-select-item.ant-select-item-option.ant-select-item-option-selected {
    background-color: ${({ theme }) => theme.hoveredDiv};
  }

  .ant-page-header-back-button:focus,
  .ant-page-header-back-button:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const Blank = styled.div`
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.21);
  margin: 0 24px;
  padding: 16px 32px 32px;
  width: 1160px;
  display: flex;
  flex-direction: row;
  position: relative;
  .ant-tabs {
    width: 100%;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${({ theme }) => theme.primary};
  }

  .ant-tabs-tab {
    &:hover,
    &:active,
    &:focus {
      color: ${({ theme }) => theme.primary};
    }
  }

  .ant-tabs-ink-bar {
    background: ${({ theme }) => theme.primary};
  }
`;

export const Button = styled(ButtonAntD)`
  &:not(.ant-btn-circle) {
    border-radius: 3px;
  }

  &.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous) {
    &:hover,
    &:focus {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const OverviewBox = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  padding: 16px;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.div`
  color: #6b7280;
  font-size: 15px;
`;

export const Text = styled.div`
  color: #6b7280;
  font-weight: 300;
  margin-top: 16px;
`;

export const CardWrapper = styled.div`
  margin-top: 24px;
  display: flex;
  gap: 8px;
  flex-direction: column;
`;

export const Card = styled.div`
  background-color: #f9fafb;
  border-radius: 3px;
  padding: 16px;
  display: flex;
`;

export const Legend = styled.div`
  font-weight: 300;
`;

export const Icon = styled.div`
  border-radius: 3px;
  background-color: #faddc9;
  width: 45px;
  height: 45px;
  margin-right: 16px;
`;

export const CardEmptyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  height: 100%;
`;

export const CardEmpty = styled.div`
  border-radius: 3px;
  padding: 16px 0;
  display: flex;
`;

export const LegendDate = styled.div`
  font-weight: 300;
  color: #9ca3af;
  font-size: 13px;
`;

export const CardText = styled.div`
  font-weight: 300;
  font-size: 14px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Col = styled.div`
  display: flex;
  align-items: center;
`;

export const SwitchWrapper = styled.div`
  font-weight: 300;
  margin-right: 16px;

  .ant-switch-checked {
    background-color: ${({ theme }) => theme.primary};
  }
`;

export const Div = styled.div`
  padding-top: 24px;
  padding-bottom: 24px;

  @media (min-width: 480px) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const Bullet = styled.div`
  background-color: ${({ active }: { active: boolean }) =>
    COLORS[active ? 'popular' : 'busy']};
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: auto;
`;

export const TableWrapper = styled.div`
  margin-bottom: 24px;

  .ant-table-thead > tr > th {
    background-color: #fff;
    font-weight: 300;
  }

  .ant-table-tbody > tr > td {
    font-weight: 300;
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.primary};
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: ${({ theme }) => theme.primary};
  }

  .ant-pagination-item-active,
  .ant-pagination-item:focus,
  .ant-pagination-item:hover {
    border-color: ${({ theme }) => theme.primary};
    a {
      color: ${({ theme }) => theme.primary};
    }
  }
  .ant-pagination-item,
  .ant-pagination-item-link,
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 3px;
  }

  .ant-pagination-prev:focus .ant-pagination-item-link,
  .ant-pagination-next:focus .ant-pagination-item-link,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    border-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.primary};
  }

  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: ${({ theme }) => theme.primary};
  }

  &:focus {
    box-shadow: 0 0 2px ${({ theme }) => theme.primary};
  }

  .ant-select.ant-pagination-options-size-changer.ant-select-single.ant-select-show-arrow.ant-select-focused
    .ant-select-selector {
    border-color: ${({ theme }) => theme.primary};
  }

  .ant-select-focused:not(.ant-select-disabled).ant-select:not(
      .ant-select-customize-input
    )
    .ant-select-selector {
    box-shadow: 0 0 2px ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }
  .ant-select-item-option-selected {
    background-color: ${({ theme }) => theme.hoveredDiv};
  }

  .ant-select-item-option-selected {
    background-color: ${({ theme }) => theme.hoveredDiv};
  }
  .ant-pagination-jump-prev
    .ant-pagination-item-container
    .ant-pagination-item-link-icon,
  .ant-pagination-jump-next
    .ant-pagination-item-container
    .ant-pagination-item-link-icon {
    color: ${({ theme }) => theme.primary};
  }
`;

export const TableEventsWrapper = styled.div`
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background: none !important;
  }

  td.timestamp {
    color: #9499a2;
    font-weight: 200;
  }

  .ant-pagination-item-active,
  .ant-pagination-item:focus,
  .ant-pagination-item:hover {
    border-color: ${({ theme }) => theme.primary};
    a {
      color: ${({ theme }) => theme.primary};
    }
  }

  .ant-pagination-jump-prev
    .ant-pagination-item-container
    .ant-pagination-item-link-icon,
  .ant-pagination-jump-next
    .ant-pagination-item-container
    .ant-pagination-item-link-icon {
    color: ${({ theme }) => theme.primary};
  }

  .ant-pagination-prev:focus .ant-pagination-item-link,
  .ant-pagination-next:focus .ant-pagination-item-link,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    border-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.primary};
  }

  .ant-select.ant-pagination-options-size-changer.ant-select-single.ant-select-show-arrow.ant-select-focused
    .ant-select-selector {
    border-color: ${({ theme }) => theme.primary};
  }
`;

export const TableIcon = styled.div`
  display: flex;
  border-radius: 8px;
  background-color: #faddc9;
  width: 25px;
  height: 25px;
  margin-right: 16px;
  justify-content: center;
  align-items: center;
`;

export const SeeAllContainer = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  gap: 4px;
  margin: 0;
  color: #9499a2;
  font-weight: 200;
  font-size: 14px;
  background: none;
`;
